<template>
    <app-content>
        <app-content-body>
            <div class="inner">
                <p class="buttons">
                    <a
                        class="btn btn_action btn_add"
                        :title="translations.addEpgSource"
                        @click.prevent="createItem"
                    ></a>
                </p>
                <h1 v-translate>Zdroje EPG</h1>
            </div>
            <app-table
                clickable
                deletable
                toggleable
                highlight-rows-on-hover
                :data="items"
                :order="params.order"
                :page-size="params.limit"
                :loading="listLoading"
                @sort="sortItems"
                @rowClick="goToDetail"
                @deleteRow="deleteItem"
                @toggleRow="toggleEpgSource"
            >
                <app-table-column first sortable attribute="name" :label="translations.name">
                    <template slot-scope="row">
                        <strong>
                          {{ row.name }}
                        </strong>
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="parser" :label="translations.parser">
                    <template slot-scope="row">
                        {{ enumsMap.get(row.parser) }}
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="enabled" :label="translations.enabled">
                    <template slot-scope="row">
                        <app-graphic-image
                                :value="row.enabled"
                        />
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="enabled" :label="translations.saveDownloadedData">
                    <template slot-scope="row">
                        <app-graphic-image
                            :value="row.saveDownloadedData"
                        />
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="triggerInterval" :label="translations.triggerInterval">
                    <template slot-scope="row">
                        {{ enumsMap.get(row.triggerInterval) }}
                    </template>
                </app-table-column>
                <app-table-column sortable attribute="dateCreated" :label="translations.created">
                    <template slot-scope="row">
                        <div v-html="formatDate(row._created)" />
                    </template>
                </app-table-column>
            </app-table>
        </app-content-body>
    </app-content>
</template>
<script>
import axios from 'axios'
import getItemsListMixin from 'mixins/getItemsListMixin'
import appTitleMixin from 'mixins/appTitleMixin'
import formatDateMixin from 'mixins/formatDateMixin'
import { VUE_APP_BASE_AUTH_URL }  from 'constants/fileConstants'

var constants = require('constants/fileConstants');

const itemsListMixin = getItemsListMixin({
    apiMethodsSuffix: 'EpgSources',
    enumsMap: true,
    additionalParams: {storedTvStations: false },
})

export default {
    name: 'epg-source',
    mixins: [formatDateMixin, itemsListMixin, appTitleMixin()],
    computed: {
        translations() {
          return {
            addEpgSource: this.$gettext('Přidat Zdroj EPG'),
              name: this.$gettext('Název'),
              parser: this.$gettext('Parser'),
              enabled: this.$gettext('Povoleno'),
              triggerInterval: this.$gettext('Interval spuštění'),
              created: this.$gettext('Založeno'),
              permitSource: this.$gettext("Povolit zdroj"),
              prohibitSource: this.$gettext("Zakázat zdroj"),
              saveDownloadedData: this.$gettext('Ukládat data')
          }
        },
        currentTitle() {
            return [
                this.$gettext('Zdroje EPG')
            ]
        },
    },
    methods: {
        toggleEpgSource(item) {
            const epgSourceId = item._id
            axios.get(VUE_APP_BASE_AUTH_URL + 'api/toggle-epg-source/' + epgSourceId)
                .then(response => {
                    this.fetchItems()
                })
                .catch(e => {
                    this.errors.push(e)
                })

        }
    }
}
</script>
